/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscWeather } from "../../funcs/miscGetMiscWeather.js";
import { GetMiscWeatherRequest$zodSchema } from "../../models/getmiscweatherop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscWeatherRequest$zodSchema.optional(),
};

export const tool$miscGetMiscWeather: ToolDefinition<typeof args> = {
  name: "misc-get-misc-weather",
  description: `查询天气

出门前，查一下天气总是个好习惯。这个接口为你提供精准、实时的天气数据，支持国内和国际城市。

## 功能概述
这个接口支持三种查询方式：
- 可以传 \`adcode\`，按行政区编码查询（优先级最高）
- 可以传 \`city\`，按城市名称查询，支持中文（\`北京\`）和英文（\`Tokyo\`）
- 两个都不传时，按客户端 IP 自动定位查询

支持 \`lang\` 参数，可选 \`zh\`（默认）和 \`en\`，城市名翻译覆盖 7000+ 城市。

## 可选功能模块
- \`extended=true\`：扩展气象字段（体感温度、能见度、气压、紫外线、空气质量及污染物分项数据）
- \`forecast=true\`：多天预报（最多7天，含日出日落、风速等详细数据）
- \`hourly=true\`：逐小时预报（24小时）
- \`minutely=true\`：分钟级降水预报（仅国内城市）
- \`indices=true\`：18项生活指数（穿衣、紫外线、洗车、运动、花粉等）

## 天气字段说明
\`weather\` 是天气现象文本，不是固定枚举。

常见值包括：晴、多云、阴、小雨、中雨、大雨、雷阵雨、小雪、中雪、大雪、雨夹雪、雾、霾、沙尘。

如果你的业务需要稳定分类，建议结合 \`weather_code\` 做自己的映射归类。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscWeather(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
